var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
var InputCell = function (props) {
    var inputRef = useRef(null);
    // remove props related to the overall component
    var description = props.description, errorMessage = props.errorMessage, displayError = props.displayError, label = props.label, inputProps = __rest(props
    // get the props that need to be handled separately
    , ["description", "errorMessage", "displayError", "label"]);
    // get the props that need to be handled separately
    var value = inputProps.value, onChange = inputProps.onChange, _a = inputProps.spellCheck, spellCheck = _a === void 0 ? false : _a, _b = inputProps.type, type = _b === void 0 ? 'text' : _b, onSubmit = inputProps.onSubmit, rest = __rest(inputProps
    /**
     * The code below doesn't work with some input types (e.g. email, number), so it has been removed.
     * Furthermore, controlling the position of the cursor seems not to be needed, as it work without as well.
     * If there's any issue with the cursor position or blur event, is more likely to be caused by the
     * parent component re-rendering by some mistake.
     */
    // const [cursor, setCursor] = useState<number | null>(value.length)
    // useEffect(() => {
    // 	const input: HTMLInputElement = inputRef.current!
    // 	// if (input) input.setSelectionRange(cursor, cursor)
    // }, [inputRef, cursor, value])
    , ["value", "onChange", "spellCheck", "type", "onSubmit"]);
    /**
     * The code below doesn't work with some input types (e.g. email, number), so it has been removed.
     * Furthermore, controlling the position of the cursor seems not to be needed, as it work without as well.
     * If there's any issue with the cursor position or blur event, is more likely to be caused by the
     * parent component re-rendering by some mistake.
     */
    // const [cursor, setCursor] = useState<number | null>(value.length)
    // useEffect(() => {
    // 	const input: HTMLInputElement = inputRef.current!
    // 	// if (input) input.setSelectionRange(cursor, cursor)
    // }, [inputRef, cursor, value])
    var handleChange = function (e) {
        // setCursor(e.target.selectionStart)
        onChange && onChange(e.target.value);
    };
    return (React.createElement("div", { className: 'w-full text-left' },
        label && React.createElement("label", { className: 'text-primary mb-2 block' }, label),
        React.createElement("input", __assign({ value: value, onChange: handleChange, spellCheck: spellCheck, type: type, className: 'border-gray-lightest bg-gray-darkest text-primary w-full rounded-lg border p-3 text-base' +
                ' ' +
                'focus:ring-accent disabled:bg-gray focus:outline-none focus:ring-2 disabled:cursor-not-allowed' +
                ' ' +
                (displayError ? "border-red border" : ''), ref: inputRef, onKeyPress: function (e) {
                var _a;
                if (props.onSubmit && e.code === 'Enter') {
                    props.onSubmit(value);
                    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                }
            } }, rest)),
        displayError && errorMessage && (React.createElement("p", { className: 'text-red mt-2 text-xs' }, errorMessage)),
        description && (React.createElement("p", { className: 'text-secondary mt-2 text-xs' }, description))));
};
export default InputCell;
